import { createLogger } from "redux-logger";

export default createLogger({
  collapsed: true,
  duration: true,
  timestamp: true,
});
